import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { Button } from "repoV2/components/common/Button";
import { useMainCtaButtonContext } from "repoV2/pages/sale/contexts/MainCtaButtonContext";
import { usePromotionalStatsSectionContext } from "repoV2/pages/sale/contexts/PromotionalStatsSectionContext";
import Rating from "react-rating";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import { useTemplate3Context } from "../../Template3Context";
import styles from "./PromotionalStatsSection.module.scss";
import commonStyles from "../../common.module.scss";
import Card from "../Card/Card";

const PromotionalStatsSection = () => {
    const { theme } = useTemplate3Context();
    const {
        ctaText,
        strikedOffText,
        onMainCtaClick,
        hide: hideCtaButton,
    } = useMainCtaButtonContext();
    const { userCount, rating, hide } = usePromotionalStatsSectionContext();

    if (hide) return null;
    return (
        <div style={{ background: theme.colors.color6 }}>
            <div
                className={classNames(
                    commonStyles.section,
                    styles.section,
                    commonStyles.maxWidthContainer
                )}
            >
                <div
                    className={styles.statsContainer}
                    style={{
                        color: theme.colors.color5,
                    }}
                >
                    <Card
                        className={classNames(
                            "d-flex flex-column align-items-center text-center",
                            styles.card
                        )}
                        style={{ background: theme.colors.color7 }}
                    >
                        <div
                            className={classNames(
                                "d-flex flex-column justify-content-center",
                                styles.statIconContainer
                            )}
                        >
                            <svg
                                width="96"
                                height="48"
                                viewBox="0 0 60 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className={styles.svgGroupProfile}
                            >
                                <path
                                    d="M29.7542 17.6137C33.7958 17.6137 37.3663 18.5807 40.2673 19.8452C42.9452 21.0354 44.6312 23.7133 44.6312 26.6143V28.1516C44.6312 29.5153 43.5154 30.6311 42.1517 30.6311H17.3566C15.9929 30.6311 14.8771 29.5153 14.8771 28.1516V26.6391C14.8771 23.7133 16.5631 21.0354 19.241 19.87C22.142 18.5807 25.7125 17.6137 29.7542 17.6137ZM9.91805 18.2335C12.6455 18.2335 14.8771 16.002 14.8771 13.2745C14.8771 10.5471 12.6455 8.31549 9.91805 8.31549C7.19059 8.31549 4.95902 10.5471 4.95902 13.2745C4.95902 16.002 7.19059 18.2335 9.91805 18.2335ZM12.7199 20.961C11.8025 20.8122 10.8851 20.7131 9.91805 20.7131C7.46333 20.7131 5.13259 21.2337 3.02501 22.1512C1.19017 22.9446 0 24.7299 0 26.7383V28.1516C0 29.5153 1.11578 30.6311 2.47951 30.6311H11.1578V26.6391C11.1578 24.5811 11.7281 22.6471 12.7199 20.961ZM49.5902 18.2335C52.3177 18.2335 54.5493 16.002 54.5493 13.2745C54.5493 10.5471 52.3177 8.31549 49.5902 8.31549C46.8628 8.31549 44.6312 10.5471 44.6312 13.2745C44.6312 16.002 46.8628 18.2335 49.5902 18.2335ZM59.5083 26.7383C59.5083 24.7299 58.3181 22.9446 56.4833 22.1512C54.3757 21.2337 52.045 20.7131 49.5902 20.7131C48.6232 20.7131 47.7058 20.8122 46.7884 20.961C47.7802 22.6471 48.3505 24.5811 48.3505 26.6391V30.6311H57.0288C58.3925 30.6311 59.5083 29.5153 59.5083 28.1516V26.7383ZM29.7542 0.876953C33.8701 0.876953 37.1927 4.1995 37.1927 8.31549C37.1927 12.4315 33.8701 15.754 29.7542 15.754C25.6382 15.754 22.3156 12.4315 22.3156 8.31549C22.3156 4.1995 25.6382 0.876953 29.7542 0.876953Z"
                                    fill="url(#paint0_linear_1366_2071)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_1366_2071"
                                        x1="29.7542"
                                        y1="0.876953"
                                        x2="50.6699"
                                        y2="26.8398"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor={theme.colors.color2} />
                                        <stop
                                            offset="1"
                                            stopColor={theme.colors.color2}
                                        />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        {userCount.value ? (
                            <div
                                className={classNames(
                                    styles.statValue,
                                    "word-break"
                                )}
                                style={{ color: theme.colors.color3 }}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: userCount.value,
                                }}
                            />
                        ) : null}

                        {userCount.description ? (
                            <small
                                className={classNames(
                                    styles.description,
                                    "font-weight-light word-break"
                                )}
                                style={{ color: theme.colors.color3 }}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: userCount.description,
                                }}
                            />
                        ) : null}
                    </Card>
                    <Card
                        className={classNames(
                            "d-flex flex-column align-items-center text-center bg-white",
                            styles.card
                        )}
                        style={{ background: theme.colors.color7 }}
                    >
                        <div
                            className={classNames(
                                "d-flex flex-column justify-content-center",
                                styles.statIconContainer,
                                styles.w100
                            )}
                        >
                            <Rating
                                className={styles.ratingWrapper}
                                placeholderRating={rating.value}
                                readonly
                                emptySymbol={
                                    <StarBorderRoundedIcon
                                        className={styles.ratingIcon}
                                        style={{
                                            color: theme.colors.color2,
                                        }}
                                    />
                                }
                                placeholderSymbol={
                                    <StarRateRoundedIcon
                                        className={styles.ratingIcon}
                                        style={{
                                            color: theme.colors.color2,
                                        }}
                                    />
                                }
                            />
                        </div>
                        <div
                            className={styles.statValue}
                            style={{ color: theme.colors.color3 }}
                        >
                            {rating.value} out of {rating.maxValue}
                        </div>
                        {rating.description ? (
                            <small
                                className={classNames(
                                    styles.description,
                                    "word-break font-weight-light"
                                )}
                                style={{ color: theme.colors.color3 }}
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: rating.description,
                                }}
                            />
                        ) : null}
                    </Card>
                </div>
                {hideCtaButton ? null : (
                    <div className="d-flex justify-content-center">
                        <Button
                            onClick={onMainCtaClick}
                            className={classNames(styles.mainCtaButton)}
                            style={{
                                background: `linear-gradient(270deg, ${theme.colors.color1} 14.14%, ${theme.colors.color2} 89.56%)`,
                                color: theme.colors.color10,
                            }}
                        >
                            {ctaText}
                            {strikedOffText ? (
                                <span className="small">
                                    &nbsp;<del>{strikedOffText}</del>
                                </span>
                            ) : null}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PromotionalStatsSection;
